// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// ExistingInstitutionCourseSearchHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import CourseDTO from '../models/CourseDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    disciplineId: string | null | null;
    catalogNumber: string | null;
    institutionId: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            disciplineId: null,
            catalogNumber: "",
            institutionId: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    disciplineId: 'disciplineId',
    catalogNumber: 'catalogNumber',
    institutionId: 'institutionId',
}

interface Result extends ResultDTO {
    course: CourseDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            course: null,
        },
        initValues);
    },
    course: 'course',
}

export { Request, Result };